<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="col-lg-12 mb-4" v-else>
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap mb-2">
                        <div class="box-ttl">Uniform request log</div>
                        <a href="/master-admin/uniforms/history" class="back-link">History</a>
                    </div>
                    <div class="buttons--row buttons--row-2 mb-3">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getUniformRequestsList"
                            ><img src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                class="search--block-txt"
                                placeholder="Search by Name"
                                v-model="filters.search_name"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="search--block">
                            <button
                                @click="getUniformRequestsList"
                                class="search--block-btn"
                                type="submit"><img
                                src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                class="search--block-txt"
                                placeholder="Search by Item"
                                v-model="filters.search_item"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="search--block">
                            <button
                                @click="getUniformRequestsList"
                                class="search--block-btn"
                                type="submit"><img
                                src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                class="search--block-txt"
                                placeholder="Search by Size"
                                v-model="filters.search_size"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="filter-wrap">
                            <label for="" class="reg-label mr-2">Filter:</label>
                            <div class="form-group form-group-2 mb-0">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change.prevent="getUniformRequestsList"
                                >
                                    <option value="all">Select One</option>
                                    <option
                                        v-for="status in statusList"
                                        :key="status.id"
                                        :value="status.id"
                                    >
                                        {{ status.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <a href="/master-admin/uniforms/requests/create" class="btn btn--outline-primary btn--middle">+
                            Add New</a>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table table-uniform">
                            <thead>
                            <tr>
                                <th>
                                    Date <br/>
                                    Requested
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('size')">Employee
                                            Name<i class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>
                                    <a href="javascript:void(0)" @click.prevent="changeSortList('item')">Item<i
                                        class="fas fa-sort"></i></a>
                                </th>
                                <th class="text-center">Size</th>
                                <th class="text-center">Qty</th>
                                <th><nobr>Primary Location</nobr></th>
                                <th>Status</th>
                                <th class="comments">Comments</th>
                                <th><nobr>Requested by</nobr></th>
                                <th class="text-right" style="width: 5rem">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="request in uniformRequests">
                                <td>
                                    <div class="text-14 color--text-gray">
                                        {{ calculateDateSlash(request.created_at) }}
                                    </div>
                                </td>
                                <td>
                                    <b>{{ request.employee.name ?? '' }}  {{ request.employee.last_name ?? '' }}</b>
                                </td>
                                <td>
                                    {{ request.uniform.title ?? ''}}
                                </td>
                                <td class="text-center">
                                    {{ request.size ?? ''}}
                                </td>
                                <td class="text-center">
                                    {{ request.quantity ?? '' }}
                                </td>
                                <td>
                                    {{ request.client ? request.client.name : request.address }}
                                </td>
                                <td>
                                    <div class="form-group form-group-1 mb-0" style="width: 210px">
                                        <select
                                            class="custom-select custom-select-blue"
                                            v-model="request.status_id"
                                            @change="updateStatus(request)">
                                            <option
                                                v-for="status in statusList"
                                                :key="status.id"
                                                :value="status.id"
                                                :selected="request.status_id"
                                            >
                                                {{ status.title }}
                                            </option>
                                        </select>
                                    </div>
                                </td>
                                <td v-if="request.comment">
                                    <p>{{ truncatedString(request.comment) }}</p>
                                    <a
                                        href="javascript:void(0)"
                                        class="color--secondary ml-2"
                                        @click="showCustomModal('comment', request.id)"
                                    ><i class="fas fa-eye"></i></a>

                                    <EyesShowModal
                                        :title="`Comments`"
                                        :modal-text="request.comment"
                                        :modalId="getCustomModalId('comment',request.id)"
                                    ></EyesShowModal>

                                </td>
                                <td v-else></td>
                                <td>
                                    <b>{{ request.requested_user.name ?? ''}} {{request.requested_user.last_name ?? '' }}</b>
                                </td>
                                <td class="text-right">
                                    <div class="action-block">
                                        <a :href="`/master-admin/uniforms/requests/${request.id}/update`"
                                           class="edit-link"
                                        ><img src="/img/svg/icons-pen.svg" alt="edit">
                                        </a>

                                        <button
                                            v-if="deletingRequest"
                                            class="delete-link"
                                            @click="showDeleteModal(request.id)"
                                        ><img src="/img/svg/on.svg" alt="delete">
                                        </button>

                                        <ActionModal confirm-text="Yes" reject-text="No"
                                                     :modalId="getDeleteModalId(request.id)"
                                                     @confirm="deleteRequestItem(request.id)">
                                            <template #body>
                                                <div class="text-center mb-4">
                                                    <h4>
                                                        Are you sure you want <br> to delete this item?
                                                    </h4>
                                                </div>
                                            </template>
                                        </ActionModal>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import UniformsService from "./service/UniformsService";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import EyesShowModal from "../../../../../resources/js/components/EyesShowModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'UniformRequestList',
    components: {Pagination, EyesShowModal, ActionModal},
    mixins: [DateConverter, StyleHandler, ModalHandler, SortDirectionHandler,PaginationHandler],
    props: {
        deletingRequest: Boolean
    },
    data() {
        return {
            loading: true,
            statusList: [],
            uniformRequests: [],
            filters: {
                search_name: '',
                search_item: '',
                search_size: '',
                status: 'all',
                sortBy: 'size',
                sortDir: 'desc',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getUniformRequestsList(filters)
        },
        async deleteRequestItem(id) {
            this.$showLoadingMessage()
            this.uniformRequests = this.uniformRequests.filter((request) => request.id !== id)
            try {
                await UniformsService.deleteRequest(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage('The request was not deleted');
            }
        },
        async getStatusList() {
            try {
                const {data: statuses} = await UniformsService.getStatusList()
                this.statusList = statuses
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        async getUniformRequestsList() {
            try {
                const {data: requests} = await UniformsService.getRequestsList(this.filters)
                this.uniformRequests = requests.data
                this.pagination.current_page = requests.current_page
                this.pagination.last_page = requests.last_page
                this.loading = false
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        async updateStatus(request) {
            this.$showLoadingMessage()
            try {
                await UniformsService.updateRequestStatus(request.id, request.status_id)
                await this.getUniformRequestsList()
                this.$showSuccessMessage('Status was updated')
            } catch (e) {
                this.$showErrorMessage('Status was not updated');
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        async loadData() {
            this.loading = true;
            try {
                await Promise.all([
                    this.getUniformRequestsList(),
                    this.getStatusList(),
                ]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.loadData()
    }
}

</script>

<style scoped>

</style>
